import { InfoBanner } from '@ui';
import { CaseFacility } from '@/api/apis/case';

type FixedPriceBannerProps = {
  txCenterDetails?: CaseFacility;
  useFixedPriceFlow: boolean;
  nonStopFlightRequired?: boolean;
};

export const FixedPriceBanner = ({
  txCenterDetails,
  useFixedPriceFlow,
  nonStopFlightRequired,
}: FixedPriceBannerProps) => {
  if (!txCenterDetails) return null;

  const isOnlyFixedPriceContract = txCenterDetails.hasFixedPriceContract && !txCenterDetails?.nonStopFlightAllowed;
  const isFixedPriceContractWithNonStopFlight =
    txCenterDetails.hasFixedPriceContract && txCenterDetails?.nonStopFlightAllowed;

  const showDefaultFixedPriceBanner =
    isOnlyFixedPriceContract || (isFixedPriceContractWithNonStopFlight && useFixedPriceFlow);
  const showNonStopFlightBanner =
    isFixedPriceContractWithNonStopFlight && (nonStopFlightRequired || !useFixedPriceFlow);

  if (showNonStopFlightBanner) {
    return (
      <InfoBanner iconType="warning">
        The TXC has fixed price contract and either NOP Request received {`<`} 6 hours to INITIAL OR time or non-stop
        flight is requested, thus the quote is generated within Route Builder
      </InfoBanner>
    );
  }

  if (showDefaultFixedPriceBanner) {
    return (
      <InfoBanner iconType="warning">
        The TXC has fixed price contract and NOP Request received {`${useFixedPriceFlow ? '>' : '<'}`} 6 hours to
        INITIAL OR time, thus the quote is {`${useFixedPriceFlow ? 'not' : ''}`} generated within Route Builder
      </InfoBanner>
    );
  }

  return null;
};
